import React from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { RiFilterOffFill } from 'react-icons/ri';
import { useApp } from '../../context/AppContext';
import QdtComponent from '../QdtComponent';
import { ClearButton, CloseIcon, Container, Content, Filter, Filters, Header, Title } from "./styles";

export default function FilterComponent() {

  const {clearAllSelections, showFilter, toggleShowFilter} = useApp()

  return (
    <Container isOpen={showFilter}>
      <Content>
        <Header>
          <Title>Filter</Title>
          <CloseIcon onClick={() => toggleShowFilter()}><AiOutlineClose size={24}/></CloseIcon>
        </Header>
        <Filters>
          <ClearButton onClick={() => clearAllSelections()}>
            <RiFilterOffFill/>
            <span style={{marginLeft: '10px'}}>Clear Selections</span>
          </ClearButton>
          <Filter>
            <QdtComponent
              type="QdtFilter"
              props={{
                cols: ['Group'],
                placeholder: 'Group',
              }}
            />
          </Filter>
          <Filter>
            <QdtComponent
              type="QdtFilter"
              props={{
                cols: ['Round'],
                placeholder: 'Round',
              }}
            />
          </Filter>
          <Filter>
            <QdtComponent
              type="QdtFilter"
              props={{
                cols: ['Side'],
                placeholder: 'Side',
              }}
            />
          </Filter>
          <Filter>
            <QdtComponent
              type="QdtFilter"
              props={{
                cols: ['Group/Team/Company'],
                placeholder: 'Group/Team/Company',
              }}
            />
          </Filter>
          <Filter>
            <QdtComponent
              type="QdtFilter"
              props={{
                cols: ['Player'],
                placeholder: 'Player',
              }}
            />
          </Filter>
          <Filter>
            <QdtComponent
              type="QdtFilter"
              props={{
                cols: ['Entrant'],
                placeholder: 'Entrant',
                single: false,
                autoSortByState: 0,
                showStateInDropdown: true,
              }}
            />
          </Filter>
          <Filter>
            <QdtComponent
              type="QdtFilter"
              props={{
                cols: ['Country'],
                placeholder: 'Country',
              }}
            />
          </Filter>
        </Filters>
      </Content>
    </Container>
  )
}